import type { TranslationMessages } from '../types';

export const navigation_groups: TranslationMessages = {
        sales_orders: 'Bán hàng & Đơn hàng',
        marketing: 'Tiếp thị',
        products: 'Sản phẩm',
        recipes_ingredients: 'Công thức & Nguyên liệu',
        inventory: 'Tồn kho',
        costs: 'Chi phí',
        staff: 'Nhân viên',
        project_management: 'Quản lý Dự án',
        settings: 'Cài đặt',
      };
